<template lang="pug" src="./custom-invisalign-testimonials.pug"></template>

<script>
import SliderText from '../../slider/text/slider-text'

export default {
  props: ['content'],
  components: {
    SliderText
  }
}
</script>



// WEBPACK FOOTER //
// custom-invisalign-testimonials.vue?53347a77